import { PERMISSION } from '@/user/permissions/permission.type';
import { useUserPermissions } from '@/user/permissions/use-user-permissions';
import { PRODUCT } from '@/user/products/product.type';
import { useUserProducts } from '@/user/products/use-user-products';

export type SettingsTabs =
  | 'apiAndIntegrations'
  | 'feed'
  | 'general'
  | 'invitedUsers'
  | 'manageTemplates'
  | 'privacy'
  | 'profileSettings'
  | 'userManagement';

export const useSettingsTabsConfig = (): {
  id: SettingsTabs;
}[] => {
  const { hasRequiredPermission } = useUserPermissions();
  const { hasRequiredProduct } = useUserProducts();

  return [
    ...(hasRequiredPermission(PERMISSION.VIEW_GENERAL_SETTINGS)
      ? ([
          {
            id: 'general',
          },
        ] as { id: SettingsTabs }[])
      : []),
    {
      id: 'profileSettings',
    },
    {
      id: 'privacy',
    },
    ...(hasRequiredProduct(PRODUCT.PERSONAL_ACCESS_TOKEN) &&
    hasRequiredPermission(PERMISSION.MANAGE_API_AND_INTEGRATIONS)
      ? ([
          {
            id: 'apiAndIntegrations',
          },
        ] as { id: SettingsTabs }[])
      : []),
    ...(hasRequiredPermission(PERMISSION.VIEW_USER_MANAGEMENT)
      ? ([
          {
            id: 'userManagement',
          },
          {
            id: 'invitedUsers',
          },
        ] as { id: SettingsTabs }[])
      : []),
    ...(hasRequiredPermission(PERMISSION.MANAGE_ACCOUNT)
      ? ([
          {
            id: 'manageTemplates',
          },
        ] as { id: SettingsTabs }[])
      : []),
    ...(hasRequiredPermission(PERMISSION.MANAGE_FEED)
      ? ([
          {
            id: 'feed',
          },
        ] as { id: SettingsTabs }[])
      : []),
  ];
};
